import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '@babel/types';
function CheckBox({ label, id, onClick, selected, isBold }) {
    return (
        <div className="custom-control custom-checkbox">
            <input
                type="checkbox"
                className="custom-control-input"
                id={id}
                onClick={onClick}
                defaultChecked={selected}
            />
            <label
                className={
                    isBold
                        ? `custom-control-label bold-label`
                        : `custom-control-label`
                }
                htmlFor={id}
            >
                {label}
            </label>
        </div>
    );
}
CheckBox.propTypes = {
    // To display the label for the checkbox
    label: PropTypes.string,
    // To distinguish the checkbox
    id: PropTypes.string.isRequired,
    // to invoke a function on press/click
    onClick: PropTypes.func,
    // to set default value
    selected: PropTypes.bool,
    // determines if the title is bold
    isBold: PropTypes.bool,
};
CheckBox.defaultProps = {
    label: null,
    onClick: noop,
    selected: true,
    isBold: false,
};
export default CheckBox;
